import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1923bc6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-403" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/403.png",
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "tip" }
const _hoisted_4 = { class: "tip" }

import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage as message } from 'element-plus'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { isAllowedAccess } from '@/apis/user'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
// 获取ip地址和用户指纹id，调取接口判断是否允许访问
fetch('https://ipcost.com/', { headers: { Accept: 'application/json' } }).then(res => res.text()).then(res => {
  var p1 = res?.match(/<small>My IP address V4<\/small>/)?.index
  if (res && p1) {
    var text = res.substring(p1, p1 + 100)
    var regex = /<strong><span class="dr ipv4">(.*?)<\/span><\/strong>/
    var match = regex.exec(text)
    if (match) {
      var ipAddress = match[1]
      console.log(ipAddress, 'ipAddress')
      FingerprintJS.load().then(fp => fp.get()).then(result => {
        const visitorId = result.visitorId
        console.log(visitorId, 'visitorId')
        isAllowedAccess({ ip: ipAddress, productId: visitorId }).then(res => {
          if (res.data === true) {
            router.push('/')
          }
        })
      })
    }
  }
})
const jump = () => {
  setTimeout(() => {
    message.success('发送成功')
  }, 1000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('该地区不支持访问，请求地址')) + "：" + _toDisplayString(_unref(store).getters.href), 1),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_unref(t)('用户IP')) + "：" + _toDisplayString(_unref(store).getters.ip) + " ", 1),
      _createElementVNode("span", { onClick: jump }, _toDisplayString(_unref(t)('点这里给我们发送错误报告')), 1)
    ])
  ]))
}
}

})